import { getValorDeMercadoColor } from "@/helpers/mui-helper";
import { toPriceInEuros } from "@/helpers/prices-helper";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const getJugadoresMercadoTableColumns = (theme) => [
    {
        id: 'fecha',
        name: 'Fecha',
        width: 120,
        center: true,
        cell: (row) => <Typography fontSize={14}>
            {row.created}
        </Typography>,
    },
    {
        id: 'valor',
        name: 'Valor',
        width: 120,
        center: true,
        cell: (row) => <Typography fontSize={14}>
            {row.marketValue}
        </Typography>,
    },
    {
        id: 'subida',
        name: 'Subida',
        width: 120,
        center: true,
        cell: (row) => (
            <Typography
                fontSize={14}
                sx={{ color: getValorDeMercadoColor(row.subida, theme) }}
            >
                {toPriceInEuros(row.subida)}
            </Typography>
        )
    }
];

const JugadoresMercadoTableColumns = () => {
    const theme = useTheme();
    return getJugadoresMercadoTableColumns(theme);
};

export default JugadoresMercadoTableColumns;
export { getJugadoresMercadoTableColumns };